var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.titulo))]),_c('div',[_vm._v(_vm._s(_vm.texto))])])}
var staticRenderFns = []

export { render, staticRenderFns }